module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-10.4cbfb011.svg";